import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { WorkshopTrainingAttendance } from '@chancenwerk/workshops/entities/WorkshopTrainingAttendance.js';

export const getWorkshopAttendanceByAccessToken = registerQuery({
  type: () => WorkshopTrainingAttendance,
  operationName: 'getWorkshopAttendanceByAccessToken',
  resolve: (accessToken: string) => {
    return async (gqlFields: BaseQLSelectionSet<WorkshopTrainingAttendance>) => {
      const col = await getRawCollection<WorkshopTrainingAttendance>(WorkshopTrainingAttendance._collectionName);
      return col.findOne({ accessToken });
    };
  },
  options: {},
  params: [{ type: () => String, name: 'accessToken' }],
});
